import React from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  getConsolidatedForecastPredictionsUrl,
  PREDICT_PRODUCT_SLUG,
  ROUTES
} from '@futrli/shared-services';
import { hasConsolidationSheetsImportEnabled } from '@futrli/organisations';

import { ConsolidatedForecastContext } from '../context/consolidated-forecast-context';
import { ConsolidationPredictionsRouterUK } from '../predictions/predictions-nav-data-controls/consolidation-predictions-router-uk';
import { ImportConsolidation } from '../reports/external-sheets/import/containers/import-consolidation/import-consolidation';
import { PredictionsInfoContext } from '../context/predictions-info-context';
import { PredictionsNavDataControls } from '../predictions/predictions-nav-data-controls/predictions-nav-data-controls';
import { SidePanelContextProvider } from './side-panel';
import { UserGridSettingsProvider } from '../reports/user-grid-settings/user-grid-settings-provider';

export const ConsolidatedForecastContainer = () => {
  const { workspaceId, organisationId, forecastId } = useParams();
  const flags = useFlags();

  return (
    <ConsolidatedForecastContext forecastId={forecastId!}>
      <UserGridSettingsProvider>
        <PredictionsInfoContext>
          <SidePanelContextProvider>
            <Routes>
              {hasConsolidationSheetsImportEnabled(flags) && (
                <Route path={ROUTES.IMPORT} element={<ImportConsolidation />} />
              )}
              <Route
                path={`${ROUTES.PREDICTIONS}/*`}
                element={
                  <PredictionsNavDataControls>
                    <ConsolidationPredictionsRouterUK />
                  </PredictionsNavDataControls>
                }
              />
              <Route
                path="*"
                element={
                  <Navigate
                    to={`${getConsolidatedForecastPredictionsUrl(
                      workspaceId!,
                      organisationId!,
                      PREDICT_PRODUCT_SLUG,
                      forecastId!
                    )}${ROUTES.SALES}`}
                  />
                }
              />
            </Routes>
          </SidePanelContextProvider>
        </PredictionsInfoContext>
      </UserGridSettingsProvider>
    </ConsolidatedForecastContext>
  );
};
